module.exports = "<div ng-if=\"item()\">{{ item().getPropertyInfo().getDisplayKeyFromAvailableValuesByCode(item().getValue()) }}</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-table/templates/typekey.html
// module id = 444
// module chunks = 0